// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type ProductListState = Readonly<{
    isFiltersDrawerOpen: boolean;
}>;

const initialProductListState: ProductListState = {
    isFiltersDrawerOpen: false,
};

const reducer = {
    "xProductList/isFiltersDrawerOpen": (draft: Draft<ProductListState>, action: { isFiltersDrawerOpen: boolean }) => {
        draft.isFiltersDrawerOpen = action.isFiltersDrawerOpen;
    },
};

const xProductList = createTypedReducerWithImmer(initialProductListState, reducer);

(reducers as any).xProductList = xProductList;

export type xProductListState = {
    xProductList: ProductListState;
};

type xProductListReducers = {
    isFiltersDrawerOpen: typeof xProductList;
};

export type xProductListActions = Parameters<xProductListReducers[keyof xProductListReducers]>[1] | AnyAction;
